import 'react-polymer' // Must be imported before React
import React, { Component } from 'react';
import StaticPage from '../StaticPage';
import localize from '../../components/localize';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { fetchShards } from '../../actions/shard';
import Select from '../../components/Select';
import FooterButton from '../../components/FooterButton';

import './Faq.css';

const questions = ['what_is_lagreport', 'what_is_score', 'is_speed_test', 'calculation', 'my_score', 'privacy', 'how_often', 'location_list'];

const defaultShard = process.env.RIOT_SHARD;

const Question = localize()(({ i18n, className, section }) => {
  const classes = classNames('faq', section, className);

  return (<section className={classes} id={section}>
            <h2>{i18n.t('header')}</h2>
            <div dangerouslySetInnerHTML={{ __html:i18n.t('body') }} />
          </section>);
});

class LocationList extends Component {
  constructor(props) {
    super(props);

    const { shards } = props;

    this.state = {
      selectedShard: props.shards ? (shards.find(shard => shard.shard === defaultShard)) : null
    };
  }

  componentWillMount() {
    this.props.fetchShards();
  }

  options() {
    const { shards, i18n } = this.props;

    return shards.map(shard => ({ label: i18n.t(`shards.${shard.shard}`, false), value: shard.shard }));
  }

  onShardSelected({ value }) {
    const { shards } = this.props;

    const selectedShard = shards.find(shard => shard.shard === value);

    this.setState({
      selectedShard
    });
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.shards && !this.state.selectedShard) {
      this.setState({
        selectedShard: nextProps.shards.find(shard => shard.shard === defaultShard)
      })
    }
  }

  render() {
    const { i18n, isLoaded } = this.props;

    if(!isLoaded)
      return null;

    const countries = this.state.selectedShard.countries.map(country => (<li key={country}>{i18n.t(`countries.${country}`, false)}</li>));

    return (<div>
              <div>
                <label>{i18n.t('region')}:</label>
                <Select name="shard" clearable={false} options={this.options()} value={this.state.selectedShard.shard} onChange={selected => this.onShardSelected(selected)} />
              </div>
              <div>
                <ul>{countries}</ul>
              </div>
            </div>);
  }
}

LocationList = compose(localize('pages.faq.questions.location_list'), connect(state => {
  return {
    isLoaded: state.shards.isLoaded,
    shards: state.shards.shards
  }
}, dispatch => {
  return {
    fetchShards: () => dispatch(fetchShards())
  }
}))(LocationList);

export default localize('pages.faq')(({ i18n }) => {
	const items = questions.map((question) => (<Question i18nPath={i18n.path('questions.' + question)} key={question} section={question} />));

	return (<StaticPage i18nPath={i18n.path()} headerAlign="left">
						<div className="centered-content">
              {items}

              <div className="country-list">
                <LocationList />
              </div>

              <FooterButton i18nPath={i18n.path('buttons.my_score')} dest="/" />
            </div>
					</StaticPage>
				 );
});



// WEBPACK FOOTER //
// ./src/pages/Faq/index.js